// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SierraLeone from '../_raw/flag/icon_flag_sierra_leone.png';

export default () => <img src={SierraLeone} alt="SierraLeone" />;
